import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mode: 'light',
  isFriendListPanelOpen: false,
  isNotificationSidebarOpen: false,
  isCartOpen: false,
  isWishlistOpen: false,
  isAvatarDropdownOpen: false,  
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    toggleFriendListPanel: (state) => {
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isFriendListPanelOpen = !state.isFriendListPanelOpen;
    },
    setFriendListPanelOpen: (state, action) => {
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isFriendListPanelOpen = action.payload;
    },
    toggleNotificationSidebar: (state) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isNotificationSidebarOpen = !state.isNotificationSidebarOpen;
    },
    setNotificationSidebarOpen: (state, action) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isNotificationSidebarOpen = action.payload;
    },
    toggleCart: (state) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isCartOpen = !state.isCartOpen;
    },
    setCartOpen: (state, action) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isCartOpen = action.payload;
    },
    toggleWishlist: (state) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isWishlistOpen = !state.isWishlistOpen;
    },
    setWishlistOpen: (state, action) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isAvatarDropdownOpen) {
        state.isAvatarDropdownOpen = false;
      }
      state.isWishlistOpen = action.payload;
    },
    toggleAvatarDropdown: (state) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      state.isAvatarDropdownOpen = !state.isAvatarDropdownOpen;
    },
    setAvatarDropdownOpen: (state, action) => {
      if (state.isFriendListPanelOpen) {
        state.isFriendListPanelOpen = false;
      }
      if (state.isNotificationSidebarOpen) {
        state.isNotificationSidebarOpen = false;
      }
      if (state.isCartOpen) {
        state.isCartOpen = false;
      }
      if (state.isWishlistOpen) {
        state.isWishlistOpen = false;
      }
      state.isAvatarDropdownOpen = action.payload;
    },
  },
});

export const { 
  setMode, 
  toggleFriendListPanel, 
  setFriendListPanelOpen, 
  toggleNotificationSidebar, 
  setNotificationSidebarOpen, 
  toggleCart, 
  setCartOpen, 
  toggleWishlist, 
  setWishlistOpen,
  toggleAvatarDropdown,
  setAvatarDropdownOpen
} = uiSlice.actions;

export default uiSlice.reducer;




